import Router from '../Router';
import { MatchCentreController } from '../../controllers';

export default class MatchCentreRouter extends Router {
	initialize( options ) {
		this.typeMenu = 'match_centre';
		this.controller   = new MatchCentreController( options );
	}
	constructor(args) {
		super(args);

		this.authOnlyDefault = false;
	}

	get appRoutes() {
		return {
			'match-centre(/:round_id)': 'matchCentreLanding',
			'match-centre/:round_id/:match_id': 'matchCentre',
		};
	}
}